class Marquee {

  static init = (params) => {
    const selMarquee = `${params.selMarquee}:not(.is-initialized)`;
    const allMarquees = document.querySelectorAll(selMarquee);

    allMarquees.forEach(marquee => {
      new Marquee(marquee, params);
    })
  }



  constructor(marquee, params) {
    this.marquee = marquee;
    this.requiredElements = params.requiredElements;
    this.clones = params.clones;

    this.modes = ['rtl', 'ltr'];
    this.currentMode = 'rtl';
    this.duration = 8;
    this.allAnimated = [];
    this.allAnimations = [];
    this.availableElements = {};

    this.markInitialized();

    this.setRequiredElements(params);
    if (!this.hasRequiredElements()) return;

    this.getData();
    if (!this.hasKnownMode()) return;

    this.container = this.marquee.querySelector(params.selContainer);
    this.animated = this.marquee.querySelector(params.selAnimated);

    this.cloneItems();
    this.setAnimation();
    this.setPauseOnHover();
  }



  markInitialized = () => {
    this.marquee.classList.add('is-initialized');
  }



  setRequiredElements(params) {
    this.requiredElements.forEach(el => {
      const selector = params[`sel${el.charAt(0).toUpperCase()}${el.slice(1)}`];
      this.availableElements[el] = this.marquee.querySelector(selector);
    });
  }



  hasRequiredElements = () => {
    const loopable = Object.entries(this.availableElements);
    
    return loopable.every(([key, value]) => {
      if (!value) {
        this.handleMissingElement(key);
        return false;
      }

      return true;
    });
  }



  getData = () => {
    this.currentMode = this.getMode();
    this.duration = this.getDuration();
  }



  getMode = () => {
    if (!this.marquee.dataset.mode) {
      this.handleMissingData('mode', this.currentMode);
      return this.currentMode;
    }

    return this.marquee.dataset.mode.toLowerCase();
  }



  getDuration = () => {
    if (!this.marquee.dataset.duration) {
      this.handleMissingData('duration', this.duration);
      return this.duration;
    }

    return parseInt(this.marquee.dataset.duration);
  }



  hasKnownMode = () => {
    if (!this.modes.includes(this.currentMode)) {
      this.handleUnkownMode(this.currentMode);
      return false;
    }

    return true;
  }



  cloneItems = () => {
    this.allAnimated.push(this.animated);

    for (let i = 0; i < this.clones; i++) {
      const cloned = this.animated.cloneNode(true);
      this.container.prepend(cloned);
      this.allAnimated.push(cloned);
    }
  }



  setAnimation = () => {
    const keyframes = this.currentMode === 'rtl'
      ? [
        { transform: 'translateX(0)' },
        { transform: 'translateX(-100%)' }
      ]
      : [
        { transform: 'translateX(-100%)' },
        { transform: 'translateX(0)' }
      ];

    this.allAnimated.forEach(animated => {
      const animation = animated.animate(keyframes, {
        duration: this.duration * 1000,
        iterations: Infinity
      });

      this.allAnimations.push(animation);
    })
  }



  setPauseOnHover = () => {
    this.container.addEventListener('mouseenter', () => {
      this.allAnimations.forEach(animation => animation.pause())
    });

    this.container.addEventListener('mouseleave', () => {
      this.allAnimations.forEach(animation => animation.play())
    });
  }



  handleMissingElement = (el) => {
    console.warn(`marquee element '${el}' is missing!`);
    console.warn('Initialising marquee was stopped!');
  }



  handleMissingData = (dataType, defaultValue) => {
    console.warn(`marquee ${dataType} is missing!`);
    console.warn(`Used default ${defaultValue}!`);
  }



  handleUnkownMode = (currentMode) => {
    console.warn(`'${currentMode} is not a marquee mode!`);
    console.warn('Initialising marquee was stopped!');
  }
}